






































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';
import { Stratification } from '@/store/types';
import StratificationDeleteButton from './StratificationDeleteButton.vue';

interface StratificationsTableRow extends Pick<Stratification, 'id'> {
	fieldId: string;
	fieldName?: string;
	groupName: string;
	submittedAt: string;
}

export default defineComponent({
	components: { StratificationDeleteButton },
	props: {
		isLoading: {
			type: Boolean,
		},
		isLoaded: {
			type: Boolean,
		},
		hasError: {
			type: Boolean,
		},
		stratifications: {
			type: Array as () => Stratification[],
			default: [],
		},
	},
	setup(props, { root }) {
		const search = ref<string>('');
		const page = ref<number>(1);
		const sortBy = ref<string[]>(['submittedAt']);
		const sortDesc = ref<boolean[]>([true]);
		const headers: DataTableHeader[] = [
			{ text: 'ID', value: 'id' },
			{ text: 'Field ID', value: 'fieldId' },
			{ text: 'Field name', value: 'fieldName' },
			{ text: 'Group', value: 'groupName' },
			{ text: 'Submitted date', value: 'submittedAt' },
			{ text: 'Demo', value: 'isDemo' },
			{ text: '', value: 'actions', sortable: false },
		];

		const tableData = computed<StratificationsTableRow[]>(() =>
			props.stratifications.map(({ id, featureOfInterest: fieldId, dateCreated, meta, isDemo }) => {
				const field = root.$store.getters['resources/getFieldById'](fieldId);
				const groupName = root.$store.getters['groups/getGroupNameById'](meta.groupId) || 'no group';

				return {
					id,
					fieldId,
					fieldName: field?.name,
					groupName,
					isDemo,
					submittedAt: dateCreated,
				};
			})
		);

		const getStratificationFromTableRow = (row: StratificationsTableRow) =>
			props.stratifications.find((stratification) => stratification.id === row.id);

		watch(search, () => (page.value = 1));

		return {
			search,
			page,
			sortBy,
			sortDesc,
			headers,
			tableData,
			getStratificationFromTableRow,
		};
	},
});
